import axios from 'axios'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { generalSummarySelector } from '../selectors'
import { handleRequestError } from './request'
import { updateAndSaveActiveTaxReturn } from './tax-return'

export const REQUEST_GENERAL_SUMMARY = 'REQUEST_GENERAL_SUMMARY'
export const RECEIVE_GENERAL_SUMMARY = 'RECEIVE_GENERAL_SUMMARY'
export const SAVE_GENERAL_SUMMARY = 'SAVE_GENERAL_SUMMARY'
const CREATE_GENERAL_SUMMARY = 'CREATE_GENERAL_SUMMARY'

export const requestGeneralSummary = (taxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_GENERAL_SUMMARY, data: { taxReturnId } })

    return axios
        .get(`/generalsummaries/${taxReturnId}`)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(
                receiveGeneralSummary({
                    fetchSuccessful: true,
                    ...responseData,
                })
            )
            return responseData
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveGeneralSummary({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveGeneralSummary({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveGeneralSummary = (data) => ({ type: RECEIVE_GENERAL_SUMMARY, data })

export const saveGeneralSummary = (data) => (dispatch, getState) => {
    dispatch({ type: SAVE_GENERAL_SUMMARY, data })

    const { id: taxReturnId } = getState().taxReturn

    return axios
        .put(`/generalsummaries/${taxReturnId}`, { ...data, taxReturnId })
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveGeneralSummary(responseData))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const updateAndSaveGeneralSummary = (data) => (dispatch, getState) => {
    const { generalSummary } = generalSummarySelector(getState())
    const updatedGeneralSummary = { ...generalSummary, ...data }

    dispatch(receiveGeneralSummary(updatedGeneralSummary))
    return dispatch(saveGeneralSummary(updatedGeneralSummary)).catch(() => {})
}

export const updateAndSaveGeneralSummaryStatus =
    ({ status }) =>
    (dispatch, getState) => {
        const { generalSummary } = generalSummarySelector(getState())
        const updatedGeneralSummary = { ...generalSummary, status }

        dispatch(receiveGeneralSummary(updatedGeneralSummary))
        return dispatch(saveGeneralSummary(updatedGeneralSummary))
            .then(() => dispatch(updateAndSaveActiveTaxReturn({ generalSummaryStatus: status })))
            .catch(() => {})
    }

export const createGeneralSummary =
    (data = {}) =>
    (dispatch, getState) => {
        const { id: taxReturnId } = getState().taxReturn

        dispatch({ type: CREATE_GENERAL_SUMMARY })

        return axios
            .put(`/generalsummaries/${taxReturnId}`, data)
            .then((response) => {
                const responseData = response?.data || {}
                dispatch(receiveGeneralSummary(responseData))
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
                return Promise.reject(error)
            })
    }

export const createOrUpdateGeneralSummary = (data) => (dispatch, getState) => {
    const { generalSummary, hasGeneralSummary } = generalSummarySelector(getState())

    const persist = hasGeneralSummary ? updateAndSaveGeneralSummary : createGeneralSummary
    return dispatch(persist({ ...generalSummary, ...data }))
}
